import { createFileRoute } from '@tanstack/react-router'
import { SanitizationDashboard } from '@/features/sanitize/sanitize-dashboard'

export const Route = createFileRoute('/_authenticated/command-center/sanitize')({
  component: SanitizationDashboard,
})
